var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgModalFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,20 C1.44771525,20 1,19.5522847 1,19 L1,2 C1,1.44771525 1.44771525,1 2,1 L19,1 C19.5522847,1 20,1.44771525 20,2 L20,19 C20,19.5522847 19.5522847,20 19,20 L2,20 Z M7,7 L7,8 L14,8 L14,7 L7,7 Z M7,9 L7,10 L14,10 L14,9 L7,9 Z M7,11 L7,12 L14,12 L14,11 L7,11 Z M7,13 L7,14 L14,14 L14,13 L7,13 Z",
  fill: "currentColor"
}))));
export default SvgModalFull;